import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";

// Page components
import Home from "layouts/pages/home";
import AboutUs from "layouts/pages/landing-pages/about-us";
import AI from "layouts/pages/landing-pages/artificial-intelligence";
import ML from "layouts/pages/landing-pages/machine-learning";
import MDev from "layouts/pages/landing-pages/mobile-app-developemt-mantainance";
import ProductDesign from "layouts/pages/landing-pages/product-design";
import GENAI from "layouts/pages/landing-pages/generative-ai";
import RemoteSupport from "layouts/pages/landing-pages/remote-desktop-support";
import CyberSecurity from "layouts/pages/landing-pages/cyber-security";
import DIGMAR from "layouts/pages/landing-pages/digital-marketing";
import WebDesign from "layouts/pages/landing-pages/web-development-maintenance";
import ContactUs from "layouts/pages/landing-pages/contact-us";
import TCsDesign from "layouts/pages/landing-pages/terms-conditions";
import PPs from "layouts/pages/landing-pages/privacy-policy";
import Refund from "layouts/pages/landing-pages/refund-policy";

// Material Kit 2 React routes (this could be a configuration file for your routes)
import routes from "routes";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // Recursive route rendering function
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {/* Define all your main routes */}
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/artificial-intelligence" element={<AI />} />
        <Route path="/machine-learning" element={<ML />} />
        <Route path="/mobile-app-development" element={<MDev />} />
        <Route path="/product-design" element={<ProductDesign />} />
        <Route path="/generative-ai" element={<GENAI />} />
        <Route path="/remote-support" element={<RemoteSupport />} />
        <Route path="/cyber-security" element={<CyberSecurity />} />
        <Route path="/digital-marketing" element={<DIGMAR />} />
        <Route path="/web-development" element={<WebDesign />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/terms-conditions" element={<TCsDesign />} />
        <Route path="/privacy-policy" element={<PPs />} />
        <Route path="/refund-policy" element={<Refund />} />

        {/* Optionally, add routes from the 'routes' configuration */}
        {getRoutes(routes)}

        {/* Fallback route to redirect all undefined paths to /home */}
      </Routes>
    </ThemeProvider>
  );
}
